import {BaseSearchableService} from "./Core/BaseSearchableService";

class UserService extends BaseSearchableService {
    get Url() { return super.Url + "/users"; }
    get ModelName() { return "User"; }
    get PrimaryKeyProperty() { return "userId"; }
    get TitleProperty() { return "name"; }

    UpdateUser(user) {
        return this.SendRequest(BaseSearchableService.PUT, user);
    }

    CreateUser(user) {
        return this.SendRequest(BaseSearchableService.POST, user);
    }

    DeleteUser(userId) {
        return this.SendRequest(BaseSearchableService.DELETE, userId);
    }

    // Self-serve read/write of per-user UI preferences; the POST response's
    // refreshed JWT carries the new claim back into redux user state.
    GetPreferences() {
        return this.SendRequest(BaseSearchableService.GET, null, null, '/preferences');
    }

    UpdatePreferences(preferences) {
        return this.SendRequest(BaseSearchableService.POST, preferences, null, '/preferences');
    }
}

export const service = new UserService();

